<template>
    <li
    v-if="$store.state.compet.length != 0 && $store.state.compet[0].name != '暂无数据'"
    class="competing-box">
        <div class="title">
            <h1>竞品</h1>
            <el-link
            type="primary"
            :underline="false"
            :href="'/enterprise/#/list?field=' + $store.state.dataList[0].a100 +'&category=' + $store.state.dataList[0].a102"
            target="_blank">
            更多></el-link>
        </div>

        <div class="con competing">
            <el-link
            :type="color[Math.round(Math.random()*color.length)]"
            v-for="(i, index) in $store.state.compet"
            :key="index"
            :href="'/enterprise/#/Inside?name=' + i.name"
            target="_blank">
            {{i.name}}</el-link>
        </div>
    </li>
</template>

<script>
export default {
    name: 'competing',
    data() {
        return {
            color: [
                'primary',
                'success',
                'warning',
                'danger',
                'info'
            ]
        }
    },
    created() {
        this.$store.dispatch('getAxios', {a102: this.$store.state.dataList[0].a102})
    }
}
</script>

<style scoped>
.competing {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

@media(max-width: 868px) {
    .competing {
        justify-content: start;
    }
    #app .competing .el-link {
        flex: 0 0 33.33%;
        line-height: 3;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
</style>